module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "import-contacts-csv"
    }
  }, [_c('router-link', {
    staticClass: "back-link-spaced",
    attrs: {
      "to": "/contatos/leads"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.back')))]), _c('h1', [_vm._v(_vm._s(_vm.$t('contacts_csv.title.index')))]), _c('step-bar', {
    attrs: {
      "current_step": _vm.current_step,
      "upload_progress": _vm.upload_progress,
      "validation_progress": _vm.validation_progress,
      "creation_progress": _vm.creation_progress,
      "steps_labels": ['Upload', 'Validação', 'Organização', 'Envio para a base'],
      "title": _vm.$t('contacts_csv.label.uploadFromFile')
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.file),
      expression: "!file"
    }],
    staticClass: "content-empty"
  }, [_c('div', {
    staticClass: "big-icon glyphicon glyphicon-cloud-upload"
  }), _c('br'), _c('input', {
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "id": "file",
      "accept": ".csv"
    },
    on: {
      "change": _vm.fileInput
    }
  }), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "onclick": "jQuery('#file').click()"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-arrow-up"
  }), _vm._v(_vm._s(_vm.$t('contacts_csv.actions.upload')))]), _c('div', {
    staticClass: "legend"
  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.label.howToCSVUpload')) + " "), _c('a', {
    staticClass: "clickable",
    on: {
      "click": _vm.exportDefaultCSV
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('contacts_csv.actions.exampleExport')) + " ")])]), _c('br')]), (_vm.loading && _vm.current_step == 2) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "loading-message"
  }, [_vm._m(0), _c('p', [_vm._v(_vm._s(_vm.$t('contacts_csv.feedback.validateUpload')))])])])]) : (_vm.file && _vm.current_step < 4) ? _c('div', [_c('div', {
    class: {
      'padding-top': _vm.loading
    },
    attrs: {
      "align": "center"
    }
  }), _c('br'), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validation_finished && !_vm.loading && _vm.current_step == 2),
      expression: "validation_finished && !loading && current_step == 2"
    }]
  }, [_c('div', {
    staticClass: "dark-slate-gray-color"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-file dark-slate-gray-color"
  }), _c('span', {
    staticClass: "spacer-10"
  }), _c('span', [_vm._v(_vm._s(_vm.file.name))])]), _c('br'), (_vm.has_line_errors) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("Seu arquivo CSV possui erros")]) : _vm._e(), (_vm.has_file_errors) ? _c('div', {
    staticClass: "alert alert-danger"
  }, _vm._l((_vm.file_errors), function(error) {
    return _c('div', [_vm._v("- " + _vm._s(error))])
  }), 0) : _vm._e(), _c('virtual-scroller', {
    staticClass: "table-responsive virtual-scroller",
    attrs: {
      "items": _vm.raw_contacts,
      "item-height": 31,
      "main-tag": "section",
      "container-tag": "table"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('tr', {
          key: props.item.index
        }, [(props.item.index < 2) ? [(props.item.index == 0) ? [_c('th'), _vm._l((_vm.attributes_reference), function(attribute_reference) {
          return _c('th', [_c('div', [_vm._v(_vm._s(attribute_reference[1]))])])
        }), _vm._l((_vm.custom_fields), function(custon_field, index) {
          return _c('th', [_c('div', [_vm._v(_vm._s(_vm.all_attributes_letters[index + _vm.fixed_columns_size] || '--'))])])
        })] : [_c('th', [_vm._v(_vm._s(_vm.has_header ? 1 : ''))]), _vm._l((_vm.attributes_reference), function(attribute_reference) {
          return _c('td', [_c('div', [_vm._v(_vm._s(_vm.humanAttribute(attribute_reference[0])))])])
        }), _vm._l((_vm.custom_fields), function(custom_field) {
          return _c('td', [_c('div', [_vm._v(_vm._s(custom_field.field))])])
        })]] : [_c('th', [_vm._v(_vm._s((props.item.index - 2) + (_vm.has_header ? 2 : 1)))]), _vm._l(((_vm.fixed_columns_size)), function(n, col_index) {
          return _c('td', {
            class: {
              "has-error": _vm.cellHasError(props.item.index - 2, col_index)
            }
          }, [_vm._v(_vm._s(props.item[col_index]))])
        }), _vm._l((_vm.custom_fields), function(custom_field, index) {
          return _c('td', {
            class: {
              "has-error": _vm.cellHasError(props.item.index - 2, index + _vm.fixed_columns_size)
            }
          }, [_vm._v(_vm._s(props.item[index + (_vm.fixed_columns_size)]))])
        })]], 2)]
      }
    }])
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.has_line_errors),
      expression: "has_line_errors"
    }]
  }, [_c('hr', {
    staticClass: "thick"
  }), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.subtitle.errorsResume')))]), _c('div', {
    staticClass: "spacer-15"
  }), _vm._l((_vm.line_errors), function(cells, error) {
    return _c('div', [_c('span', {
      staticClass: "glyphicon glyphicon-alert light-red-color"
    }), _c('span', {
      staticClass: "spacer-10"
    }), _c('span', {
      staticClass: "dark-slate-gray-color bold"
    }, [_vm._v(_vm._s(_vm.humanCells(cells)))]), _c('span', {
      staticClass: "spacer-5"
    }), _c('span', {
      staticClass: "text-gray-color"
    }, [_vm._v(_vm._s(error))]), _c('div', {
      staticClass: "spacer-10"
    })])
  })], 2), _c('hr', {
    staticClass: "thick"
  }), _c('div', [_c('span', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.subtitle.nextStepsCheck')))]), _c('div', {
    staticClass: "spacer-10"
  }), _c('div', [_c('span', {
    staticClass: "glyphicon glyphicon-alert yellow-color"
  }), _c('span', {
    staticClass: "spacer-10"
  }), _c('span', {
    staticClass: "text-gray-color"
  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.label.nextStepsCheck1')) + " ")])]), _c('div', [_c('span', {
    staticClass: "glyphicon glyphicon-alert yellow-color"
  }), _c('span', {
    staticClass: "spacer-10"
  }), _c('span', {
    staticClass: "text-gray-color"
  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.label.nextStepsCheck2')) + " ")]), _c('dropdown-select', {
    attrs: {
      "options": _vm.encoding_options
    },
    on: {
      "input": _vm.importWithEncoding
    },
    model: {
      value: (_vm.encoding),
      callback: function($$v) {
        _vm.encoding = $$v
      },
      expression: "encoding"
    }
  })], 1)]), _c('hr', {
    staticClass: "thick"
  }), _c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-gray",
    attrs: {
      "to": "/contatos/leads"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')) + " ")]), (_vm.has_errors) ? _c('span', {
    attrs: {
      "id": "import_buttons"
    }
  }, [(_vm.has_errors) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "import_fixed_csv",
      "onclick": "jQuery('#file').click()"
    }
  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.actions.importAfterCheck')) + " ")]) : _vm._e(), ((_vm.has_valid && _vm.has_errors) || _vm.has_duplicates) ? _c('div', {
    staticClass: "dropdown dropup",
    attrs: {
      "id": "dropdownElement",
      "text": "Action",
      "type": "primary",
      "data-toggle": "dropdown"
    }
  }, [_c('div', {
    staticClass: "user-miniature-wrapper dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        return _vm.menu_open_change()
      }
    }
  }, [(_vm.menu_open == true) ? _c('span', {
    staticClass: "glyphicon glyphicon-menu-up"
  }) : _c('span', {
    staticClass: "glyphicon glyphicon-menu-down"
  })]), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right",
    attrs: {
      "id": "import_fixed_csv_dropdown_menu"
    }
  }, [_c('li', [(_vm.has_valid && _vm.has_errors) ? _c('a', {
    on: {
      "click": _vm.confirmImportValidOnly
    }
  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.actions.contactsImportOnlyFine')) + " ")]) : _vm._e()]), _c('li', [(_vm.has_duplicates) ? _c('a', {
    on: {
      "click": _vm.workOnDuplicates
    }
  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.actions.contactsImportDuplicated')) + " ")]) : _vm._e()])])]) : _vm._e()]) : _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.actions.nextStepsCheckedContinue')) + " ")]), _c('confirm-modal', {
    attrs: {
      "id": "confirm-select-duplicate-confirmation-modal",
      "title": "Confirmar a seleção de contatos duplicados",
      "message": _vm.message,
      "confirm_text": "Confirmar",
      "confirm_class": "btn-primary",
      "reject_text": "Cancelar"
    },
    on: {
      "confirm-modal-confirm": function($event) {
        return _vm.update(true)
      },
      "confirm-modal-reject": function($event) {
        return _vm.update(false)
      }
    }
  })], 1)], 1)]) : _vm._e(), (_vm.current_step == 3) ? _c('organization-step', {
    attrs: {
      "multiple_groups": _vm.multiple_groups,
      "groups": _vm.groups,
      "remaining": _vm.remaining
    },
    on: {
      "groupSwitch": _vm.switchGroup,
      "flowSwitch": _vm.switchFlow,
      "fillGroup": _vm.selectGroup,
      "fillFlow": _vm.selectFlow,
      "tagsUpdated": _vm.selectTags,
      "userUpdated": _vm.selectUser,
      "remainingContacts": _vm.switchRemaining
    }
  }) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [(_vm.current_step >= 4) ? _c('div', {
    staticClass: "loading-message"
  }, [(!_vm.import_finished) ? [_vm._m(1), _c('p', [_vm._v(_vm._s(_vm.$t('contacts_csv.feedback.sendingContacts')) + " ")])] : [_c('img', {
    staticClass: "last",
    attrs: {
      "src": require("../../../assets/images/lead-gen-loading/loaded.png")
    }
  }), _c('p', [_vm._v(_vm._s(_vm.$t('contacts_csv.feedback.contactsSent')) + " ")]), _c('br'), _c('router-link', {
    staticClass: "btn btn-primary go-to-contacts",
    attrs: {
      "to": "/contatos/leads"
    }
  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.actions.backToContactsPage')) + " ")]), _c('br'), _c('a', {
    on: {
      "click": _vm.newImport
    }
  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.actions.newImport')) + " ")])]], 2) : _vm._e()])]), _c('div', {
    staticClass: "text-center"
  }, [(_vm.current_step == 3) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.confirmImport
    }
  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.actions.contactImport')) + " ")]) : _vm._e()]), _c('confirm-modal', {
    attrs: {
      "id": "confirm-flow-select-confirmation-modal",
      "title": _vm.$t('contacts_csv.label.importConfirmTitle'),
      "message": _vm.$t('contacts_csv.label.importConfirmMessage'),
      "confirm_text": _vm.$t('general.actions.confirm'),
      "confirm_class": "btn-primary",
      "reject_text": _vm.$t('general.actions.cancel')
    },
    on: {
      "confirm-modal-confirm": function($event) {
        return _vm.updateActiveInFlow(true)
      },
      "confirm-modal-reject": function($event) {
        return _vm.updateActiveInFlow(false)
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animation-loading"
  }, [_c('img', {
    staticClass: "first",
    attrs: {
      "src": require("../../../assets/images/lead-gen-loading/loading-1.png")
    }
  }), _c('img', {
    staticClass: "second",
    attrs: {
      "src": require("../../../assets/images/lead-gen-loading/loading-2.png")
    }
  }), _c('img', {
    staticClass: "third",
    attrs: {
      "src": require("../../../assets/images/lead-gen-loading/loading-3.png")
    }
  }), _c('img', {
    staticClass: "fourth",
    attrs: {
      "src": require("../../../assets/images/lead-gen-loading/loading-4.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animation-loading"
  }, [_c('img', {
    staticClass: "first",
    attrs: {
      "src": require("../../../assets/images/lead-gen-loading/loading-1.png")
    }
  }), _c('img', {
    staticClass: "second",
    attrs: {
      "src": require("../../../assets/images/lead-gen-loading/loading-2.png")
    }
  }), _c('img', {
    staticClass: "third",
    attrs: {
      "src": require("../../../assets/images/lead-gen-loading/loading-3.png")
    }
  }), _c('img', {
    staticClass: "fourth",
    attrs: {
      "src": require("../../../assets/images/lead-gen-loading/loading-4.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-85c28e08!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contacts/import/csv.vue
// module id = 1184
// module chunks = 1